import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ListaContactos } from 'src/app/interfaces/ListaContactosData';
import { ListaContactosService } from 'src/app/service/listaContactos.service';

@Component({
  selector: 'app-editar-contactos',
  templateUrl: './editar-contactos.component.html',
  styleUrls: ['./editar-contactos.component.scss'],
  providers: [MessageService]
})
export class EditarContactosComponent implements OnInit {
  deviceUrl: string = '';
  deviceName: string = '';
  contactos: ListaContactos[] = [];
  lista: ListaContactos = {
    nombre: '',
    tipoLista: '',
    lista: '',
    token: '',
    id: '',
    updated_at: 0,
  };

  id!: string;

  validar: boolean = true;

  archivoSeleccionado: File | null = null;

  ingresoManualSeleccionado: boolean = true;
  importacionCsvSeleccionada: boolean = false;

  soloNumerosValidacion: RegExp = /^[0-9\s]+$/;

  constructor(private route: ActivatedRoute, private contactosService: ListaContactosService, private messageService: MessageService, private router: Router,
    private formBuilder: FormBuilder, private translate: TranslateService) {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.id = id;
    } else {
      console.error('El ID del registro no está disponible.');
    }
     // Establecer idiomas disponibles y el idioma por defecto
     translate.addLangs(['en', 'es']);
     translate.setDefaultLang('es');
  }


  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      
      if (this.id) {
        // Llama al servicio para obtener los detalles de la lista por su ID
        this.contactosService.getListaById(this.id)
          .subscribe((lista: ListaContactos) => {
            this.lista = lista;
          }, error => console.log(error));
      }
    });

    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      const nombre = params['deviceName'] || '';
      if (token) {
        this.deviceUrl = token;
      } 
      if(nombre){
        this.deviceName = nombre;
      }
    });
    this.opcionSeleccionada();
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  opcionSeleccionada(){
    if(this.ingresoManualSeleccionado){
      this.importacionCsvSeleccionada = false;
    } else if(this.importacionCsvSeleccionada){
      this.ingresoManualSeleccionado = false;
    }
  }

  // Función para manejar el cambio en la selección de opciones
  cambioSeleccion(option: number) {
    if (option === 1) {
      this.ingresoManualSeleccionado = true;
      this.importacionCsvSeleccionada = false;
    } else if (option === 2) {
      this.ingresoManualSeleccionado = false;
      this.importacionCsvSeleccionada = true;
    }
  }

  BuscarRegistro(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        // Llama al servicio para obtener los detalles de la lista por su ID
        this.contactosService.getListaById(id)
          .subscribe((lista: ListaContactos) => {
            this.lista = lista;
          });
      } else {
        alert("El ID del registro no es válido");
      }
    });
  }
  
  
  

  // Método para manejar la selección de archivos
  onFileSelected(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.archivoSeleccionado = fileList[0];
    }
  }


  actualizarLista(): void {
    if(this.lista.nombre === "" || this.lista.tipoLista === "" || this.lista.lista === ""){
      this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_FIELDS')})
      this.validar = true;
      return;
    }
    this.lista.token = this.deviceUrl;
    if (this.id) {
      if (this.archivoSeleccionado) {
        // Llama al servicio para actualizar la lista, pasando el ID, la lista actualizada y el archivo seleccionado
        this.contactosService.updateLista(this.id, this.lista, this.archivoSeleccionado)
          .subscribe(() => {
            this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('LIST_MODIFIED')});          
            setTimeout(()=>{this.router.navigate(['/contact-list'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
            queryParamsHandling: 'merge'})},2500)
          });
      } else {
        // Llama al servicio para actualizar la lista solo con los datos de la lista
        this.contactosService.updateLista(this.id, this.lista, null)
          .subscribe(() => {
            this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('LIST_MODIFIED')})
            setTimeout(()=>{this.router.navigate(['/contact-list'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
            queryParamsHandling: 'merge'})},2500)
          });
      }
    } else {
      console.error("El ID del registro no está disponible.");
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_LIST_MODIFIED')});
    }
  }

  regresar(deviceUrl: string, deviceName: string){
    this.router.navigate(['/contact-list'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
    queryParamsHandling: 'merge' });
  }

  verificarSoloNumeros(texto: string): boolean {
    return this.soloNumerosValidacion.test(texto);
  }

}
